// A fonte é `constants/Anexos.js` (util e mixin importam de lá); este arquivo só
// mantém o caminho antigo dos consumidores do composer.
export { STATUS_UPLOAD } from '@modules/aawz-intelligence-v2/constants/Anexos'
